export const TURNSTILE_SCRIPT_ID = 'cf-turnstile-script';
export const TURNSTILE_SCRIPT_SRC =
  'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';

export type TurnstileRenderOptions = {
  sitekey: string;
  callback?: (token: string) => void;
  'expired-callback'?: () => void;
  'error-callback'?: () => void;
};

declare global {
  interface Window {
    turnstile?: {
      render: (container: string | HTMLElement, options: TurnstileRenderOptions) => string;
      reset: (widgetId?: string) => void;
      remove: (widgetId?: string) => void;
    };
  }
}

export function getTurnstileSiteKey(): string {
  return (process.env.REACT_APP_TURNSTILE_SITE_KEY || '').trim();
}

function isPrivateDevHost(hostname: string): boolean {
  return (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname === '::1' ||
    hostname.endsWith('.local') ||
    /^192\.168\./.test(hostname) ||
    /^10\./.test(hostname)
  );
}

export function isTurnstileEnforced(): boolean {
  const explicitBypass = (process.env.REACT_APP_TURNSTILE_BYPASS || '').toLowerCase() === 'true';
  const enforceLocal =
    (process.env.REACT_APP_TURNSTILE_ENFORCE_LOCAL || '').toLowerCase() === 'true';

  if (process.env.NODE_ENV === 'development' || explicitBypass) {
    return false;
  }

  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
  if (isPrivateDevHost(hostname) && !enforceLocal) {
    return false;
  }

  return Boolean(getTurnstileSiteKey());
}

export function removeTurnstileWidget(widgetId: string | undefined): void {
  if (widgetId && window.turnstile?.remove) {
    window.turnstile.remove(widgetId);
  }
}

export {};
